module.exports = __webpack_public_path__ + "images/emoji/tired_face.2297a77388adc6c4b392.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tired_face.png
// module id = DBEX
// module chunks = 13